import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import moment from 'moment';
import { AlertsActions } from '../../../../../../store';
import { CommentType } from '../../../../../../store/alerts/types';
import { InlineEditable } from '../../../../../InlineEditable';
import { PrimaryButton } from '../../../../../PrimaryButton';

import './InformationCommentsDashboard.css';

interface Props {
  commentApiLocation: string;
  comments: CommentType[];
  updateComment(comment: string, apiLocation: string): Promise<any>;
  addComment(comment: string, apiLocation: string): Promise<any>;
  triggerRefetch(): void;
}

interface State {
  newComment: string;
  editedComment: Map<string, string>;
  isEditing: boolean;
}

export class InformationCommentsDashboard extends Component<Props, State> {
  state = {
    newComment: '',
    editedComment: Map() as Map<string, string>,
    isEditing: false,
  };

  setEditingState = (isEditing: boolean) => {
    this.setState((state) => ({
      ...state,
      isEditing,
    }));
  };

  updateEditable = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    this.setState((state) => ({
      editedComment: state.editedComment.set(name, value),
    }));
  };

  keyPressed = (e: React.KeyboardEvent<HTMLDivElement>, updateApiLocation: string) => {
    const { key } = e;

    if (key === 'Enter') {
      this.updateComment(e, updateApiLocation);
    }
  };

  updateComment = async (e: any, updateApiLocation: string) => {
    const { updateComment, triggerRefetch } = this.props;
    const { editedComment } = this.state;
    const { name, value } = e.target;

    if (editedComment.has(name)) {
      const commentUpdated = await updateComment(value, updateApiLocation);

      if (commentUpdated) {
        triggerRefetch();
      }
    }
  };

  addComment = async () => {
    const { commentApiLocation, addComment, triggerRefetch } = this.props;
    const { newComment } = this.state;

    const commentAdded = await addComment(newComment, commentApiLocation);

    if (commentAdded) {
      triggerRefetch();
    }
  };

  handleTextChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    e.persist();
    const { name, value } = e.target;

    this.setState((state) => ({
      ...state,
      [name]: value,
    }));
  };

  render() {
    const { comments } = this.props;
    const { newComment, editedComment } = this.state;

    return (
      <div className="information-comments">
        {comments.map((commentItem) => {
          const { api_location, comment, created, uid_hash, user } = commentItem;

          const isEditing = editedComment.has(uid_hash);

          return (
            <div key={uid_hash} className="comment-item-box">
              <div className="comment-item-box__top-row">
                <div>{user}</div>
                <div>{moment(created).format('LLL')}</div>
              </div>
              <div className="comment-item-box__comment">
                <InlineEditable placeholder="" text={comment} type="input" setEditingState={this.setEditingState}>
                  <input
                    id={`${uid_hash}-comment`}
                    style={{ fontSize: '16px', width: '100%', height: '100%' }}
                    className="comment-item-box__comment-input"
                    name={uid_hash}
                    value={isEditing ? editedComment.get(uid_hash) : comment}
                    onChange={(e) => this.updateEditable(e)}
                    onBlur={(e) => this.updateComment(e, api_location)}
                    onKeyUp={(e) => this.keyPressed(e, api_location)}
                    autoFocus
                  />
                </InlineEditable>
              </div>
            </div>
          );
        })}
        <textarea
          id="newComment-input"
          className="information-comments__new-comment-box"
          name="newComment"
          value={newComment}
          onChange={(e) => this.handleTextChange(e)}
        />
        <div className="information-comments__button-row">
          <PrimaryButton label="Comment" isDisabled={!newComment} onClick={this.addComment} />
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = {
  updateComment: AlertsActions.updateComment,
  addComment: AlertsActions.addComment,
};

export const ConnectedInformationCommentsDashboard = connect(null, mapDispatchToProps)(InformationCommentsDashboard);
